import { useEffect, useRef } from 'react';
import style from './GoogleMap.module.css';

const GoogleMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const initMap = () => {
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: 52.1777538, lng: 21.0269751 }, // Точні координати з Google Maps
        zoom: 16,
      });

      // Додаємо маркер у точному місці
      new window.google.maps.Marker({
        map,
        position: { lat: 52.1777538, lng: 21.0269751 },
        title: 'Artemida Studio', // Назва маркера
      });
    };

    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDraTYpNyyjOh3GOLw2AheHZj7WY2TjiW8&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = initMap;
      document.head.appendChild(script);
    } else {
      initMap();
    }
  }, []);

  return (
    <div className={style.googleMap}>
      <div
        ref={mapRef}
        style={{ width: '100%', height: '400px', borderRadius: '8px' }}
      />
    </div>
  );
};

export default GoogleMap;
